import { render } from "./SliderCareers.vue?vue&type=template&id=c98cadba&scoped=true"
import script from "./SliderCareers.vue?vue&type=script&lang=js"
export * from "./SliderCareers.vue?vue&type=script&lang=js"

import "./SliderCareers.vue?vue&type=style&index=0&id=c98cadba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98cadba"]])

export default __exports__